import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import template from './admin-server.hbs'
import i18n from 'scoreboard/components/i18n'
import DisplayHeader from 'scoreboard/components/display-header'
import formHelper from 'scoreboard/components/form-helper'
import FormView from 'scoreboard/components/form-view'
import emailValidator from 'scoreboard/components/validators/email-validator'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import hostValidator from 'scoreboard/components/validators/host-validator'
import positiveIntegerValidator from 'scoreboard/components/validators/positive-integer-validator'
import numericEvaluator from 'scoreboard/components/evaluators/numeric-evaluator'
import formatValue from 'scoreboard/components/format-value'
import MarkedField from 'scoreboard/components/marked-field'
import select from 'scoreboard-select'
import TextArea from 'scoreboard/components/textarea'
import config from 'scoreboard/components/config'
import DataType from 'scoreboard/datasets/model/data-type'
const { NUMBER } = DataType

var AdminServer = Backbone.View.extend({

	// this.options.config is the config from the server

	tagName: 'form',

	className: 'admin table-hack display-layout admin-server',

	events: {
		'click .cancel': 'cancel'
	},

	initialize: function(options) {
		this.options = options || []
		this.formView = new FormView({ el: this.el, submit: this.submit.bind(this) })
	},

	render: function() {
		this.$el.empty().append(new DisplayHeader({
			heading: i18n.get('admin.group.abilities.serverConfigure'),
			mobileGearHidden: true
		}).render().el, template())

		if (config.passwordless) { // See AuthenticationType#isPasswordless (#29010)
			this.textArea = new TextArea({el: this.$('textarea[name=splashScreenMessage]')})
				.render()
				.on('resize', () => this.trigger('resize'))

			this.textArea = new TextArea({el: this.$('textarea[name=splashScreenFooter]')})
				.render()
				.on('resize', () => this.trigger('resize'))
		} else {
			this.$('.sms-splash').addClass('is-not-displayed')
		}

		this.markFields()
		formHelper.writeToDom(this.formattedConfigValues(), this.el)
		this.formView.start()
		select(this.el.querySelectorAll('select'))
		return this
	},

	/**
	 * Returns a clone of this.options.config with any needed formatting applied
	 */
	formattedConfigValues: function() {
		let values = _.clone(this.options.config)
		values['maxDatasetSize'] = formatValue({
			value: values['maxDatasetSize'],
			dataType: NUMBER,
			shorten: false
		})
		return values
	},

	// make fields instances of marked-field, as appropriate
	markFields: function() {
		this.markedFields = []
		this.markedFields.push(new MarkedField({
			el: this.$('[name=adminEmail]'),
			validators: [requiredValidator, emailValidator]
		}).render())
		this.markedFields.push(new MarkedField({
			el: this.$('[name=errorEmail]'),
			validators: [requiredValidator, emailValidator]
		}).render())
		this.markedFields.push(new MarkedField({
			el: this.$('[name=adminPassword]'),
			validator: requiredValidator
		}).render())
		// only verify passwords match when bluring on the password confirmation.
		// we don't want to show two errors, and we don't want to show an error
		// when first moving from the password to the confirmation password
		this.markedFields.push(new MarkedField({
			el: this.$('[name=adminPassword2]'),
			validators: [requiredValidator, this._passwordsMatch.bind(this)]
		}).render())
		this.markedFields.push(new MarkedField({
			el: this.$('[name=serverHost]'),
			validators: [requiredValidator, hostValidator]
		}).render())
		this.markedFields.push(new MarkedField({
			el: this.$('[name=serverPort]'),
			validators: [requiredValidator, positiveIntegerValidator]
		}).render())
		this.markedFields.push(new MarkedField({
			el: this.$('[name=serverContext]'),
			validators: [function(val){ return 'api' === _.lowerCase(val)
							 ? i18n.get('admin.serverConfiguration.server.context.invalid')
							 : undefined}]
		}).render())
		this.markedFields.push(new MarkedField({
			el: this.$('[name=smtpHost]'),
			validators: [hostValidator]
		}).render())
		this.markedFields.push(new MarkedField({
			el: this.$('[name=smtpPort]'),
			validators: [positiveIntegerValidator]
		}).render())
		this.markedFields.push(new MarkedField({
			el: this.$('[name=exportServerHost]'),
			validators: [hostValidator]
		}).render())
		this.markedFields.push(new MarkedField({
			el: this.$('[name=exportServerPort]'),
			validators: [positiveIntegerValidator]
		}).render())
		this.markedFields.push(new MarkedField({
			el: this.$('[name=offlineDbPingInterval]'),
			validators: [positiveIntegerValidator],
			markerContent: i18n.get('admin.import.schedule.minutes')
		}).render())
		this.markedFields.push(new MarkedField({
			el: this.$('[name=maxDatasetSize]'),
			dataType: NUMBER,
			evaluator: numericEvaluator,
			validator: [positiveIntegerValidator],
			markerContent: i18n.get('datasets.records')
		}).render())
	},

	// returns an error message if the passwords don't match
	_passwordsMatch: function() {
		var password = this.$('[name=adminPassword]').val()
		var confirmPassword = this.$('[name=adminPassword2]').val()
		if (password !== confirmPassword) {
			return i18n.get('common.error.passwordsMustMatch')
		}
	},

	cancel: function() {
		formHelper.writeToDom(this.formattedConfigValues(), this.el)
		this.formView.start()
	},

	submit: function() {
		var data = formHelper.readFromDom(this.el)
		return $.ajax({
			method: 'post',
			url: 'api/admin/server',
			data: JSON.stringify(data),
			success: function(result) {
				this.formView.start()
			}.bind(this),
			error: function(xhr) {
				this.formView.error(xhr)
			}.bind(this)
		})
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap(this.markedFields, 'remove')
		_.invokeMap([this.formView, this.textArea], 'remove')
	}

})

export default AdminServer

AdminServer.__filename__ = 'admin/configuration/admin-server.js'
